module.exports = __webpack_public_path__ + "img/fuochi-d-artificio-immagine-animata-0080.daca5f24.gif";